import React, { useState } from "react";
import { useForm } from 'react-hook-form';
import { ToastContainer } from 'react-toastify';
import FirebaseAuthService from '../../services/firebaseAuthService';
import toaster from '../../helpers/toaster';
import { Link } from "react-router-dom";

const Header = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showResetView, setShowResetView] = useState(false);
  const [not_a_subs_one, setNot_a_subs_one] = useState(false);
  const [not_a_subs_two, setNot_a_subs_two] = useState(false);
  const { register, handleSubmit, getValues, formState: { errors } } = useForm();
  const {
    register: register2,
    formState: { errors: errors2 },
    handleSubmit: handleSubmit2,
  } = useForm();
  
  const {
    register: register3,
    formState: { errors: errors3 },
    handleSubmit: handleSubmit3,
  } = useForm();

  const firebaseAuth = new FirebaseAuthService();

  const handleChange = () => {
    setNot_a_subs_one(!not_a_subs_one);
  }

  const handleChangesec = () => {
    setNot_a_subs_two(!not_a_subs_two);
  }

  async function onSignUp(data, e) {
    setIsLoading(!isLoading);
    const body = {
      "email": data.email,
      "password": data.password,
      "company": data.company,
      "symplr_badge_ID": data.symplr_badge_ID,
      "intelli_badge_ID": data.intelli_badge_ID,
      "not_a_subs_one": not_a_subs_one,
      "not_a_subs_two": not_a_subs_two,
    }
    firebaseAuth.register(body).then(data => {
        if (data.success === true) {
          setIsLoading(false);
          new toaster().successMessage(data.message);
          e.target.reset();
          // Close modal
          document.querySelector('#ModalRegistration .btn-close').click();
        } else if (data.success === false) {
          setIsLoading(false);
          if (data.message.email) {
            new toaster().errorMessage(data.message.email[0]);
          }
        }
      }
    );
  }

  async function onLogin(data, e) {
    setIsLoading(!isLoading);
    firebaseAuth.login(data).then(data => {
        if (data.success === true) {
          setIsLoading(isLoading);
          window.location.href = "/calendar";
          new toaster().successMessage(data.message);
          e.target.reset();
          // Close modal
          document.querySelector('[data-bs-dismiss="modal"]').click();
        } else {
          setIsLoading(false);
          if (data.message.message) {
            new toaster().errorMessage(data.message.message[0]);
          }
        }
      }
    );
  }

  async function onResetPassword(data) {
    setIsLoading(true);
    const result = await firebaseAuth.resetPassword(data.email);
    setIsLoading(false);
    if (result.success) {
      new toaster().successMessage(result.message);
      setShowResetView(false); // Switch back to login view
    } else {
      new toaster().errorMessage(result.message);
    }
  }

  // Google Sign In function
  async function onGoogleSignIn() {
    setIsLoading(true);
    firebaseAuth.signInWithGoogle().then(data => {
      if (data.success === true) {
        setIsLoading(false);
        new toaster().successMessage(data.message);
        // Close modal and redirect
        document.querySelector('[data-bs-dismiss="modal"]').click();
        window.location.href = "/calendar";
      } else {
        setIsLoading(false);
        if (data.message.message) {
          new toaster().errorMessage(data.message.message[0]);
        }
      }
    });
  }



  return (

    <>
      <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      />
      <nav className="navbar navbar-expand-sm navbar-dark">
        <div className="container">
          <Link className="navbar-brand" to="javascript:void(0)"> <img src="\images\logo.jpg" width={'100'} alt="replinq" /></Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar">
            <span className="navbar-toggler-icon"></span>
            <span className="navbar-toggler-icon"></span>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="mynavbar">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="#aboutus">About Us</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="#contactus">Contact Us</Link>
              </li>
            </ul>
          </div>
          <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#mylogin">
            Login
          </button>
          <div className="modal loginM" id="mylogin">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className='row'>
                    <div className='col-12 col-md-6'>
                      <img src="\images\loginPopLeftImg.png" className='leftImg' alt="" />
                    </div>
                    <div className='col-12 col-md-6'>
                      <button type="button" className="btn-close loginmdl" data-bs-dismiss="modal"></button>

                      <div className='formWrap'>
                        {showResetView ? (
                          <>
                            <span className='weback'>Forgot Your Password?</span>
                            <h2>Password Reset</h2>
                            <form onSubmit={handleSubmit3(onResetPassword)}>
                              <div className='row'>
                                <div className='col-12 mb-4'>
                                  <input type='text' className='form-control' {...register3("email", {
                                    required: "Email is required",
                                    pattern: {
                                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                      message: "Email is invalid"
                                    }
                                  })} id='email' placeholder='Enter your email' name='email' />
                                  {errors3.email && <p className="errorMessage">{errors3.email.message}</p>}
                                </div>
                                <div className='col-12'>
                                  <input type='submit' disabled={isLoading} className='btn btn-primary' value='Send Reset Link'></input>
                                </div>
                                <div className='col-12 mt-4 mb-4 text-center'>
                                  <Link to='#' onClick={() => setShowResetView(false)} className='text-underline'>Back to Login</Link>
                                </div>
                              </div>
                            </form>
                          </>
                        ) : (
                          <>
                            <span className='weback'>Welcome Back!</span>
                            <h2>Login to your account</h2>
                            <form onSubmit={handleSubmit2(onLogin)}>
                              <div className='row'>
                                <div className='col-12 mb-4'>
                                  <input type='text' className='form-control' {...register2("email", {
                                required: "Email is required"
                              })} id='email' placeholder='Email' name='email' />
                              {errors2.email ? (
                                <>
                                  {errors2.email.type === "required" && (
                                    <p className="errorMessage">
                                      {errors2.email.message}
                                    </p>
                                  )}
                                </>
                              ) : null}
                            </div>
                            <div className='col-12 mb-4'>
                              <input type='password' className='form-control' {...register2("password", {
                                required: "Password is required"
                              })} placeholder='Password' name='password' />
                              {errors2.password ? (
                                <>
                                  {errors2.password.type === "required" && (
                                    <p className="errorMessage">
                                      {errors2.password.message}
                                    </p>
                                  )}
                                </>
                              ) : null}
                            </div>
                            <div className='col mb-4'>
                              <label className="form-check-label">
                                <input type="radio" className="form-check-input" name="optradio" /> Remember Me
                              </label>
                            </div>
                            <div className='col mb-4'>
                              <Link to='#' onClick={() => setShowResetView(true)} className='float-right'>Forget Password</Link>
                            </div>
                            <div className='col-12'>
                              <input type='submit' disabled={isLoading} className='btn btn-primary' value='Login'></input>
                            </div>
                            <div className='col-12 mt-3 mb-3 text-center'>
                              <div className='divider'>
                                <span>OR</span>
                              </div>
                            </div>
                            <div className='col-12 mb-3'>
                              <button 
                                type='button' 
                                className='btn btn-outline-danger w-100 d-flex align-items-center justify-content-center' 
                                onClick={onGoogleSignIn}
                                disabled={isLoading}
                              >
                                <img src="/images/icons/google-logo.svg" alt="Google" style={{ marginRight: '10px', height: '20px' }} /> Sign in with Google
                              </button>
                            </div>
                            <div className='col-12 mt-4 mb-4 text-center'>
                              Don't have an account <Link data-bs-toggle="modal" data-bs-target="#ModalRegistration" to='#' className='text-underline'>Sign Up</Link>
                            </div>
                          </div>
                        </form>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div className="heroBanner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-5">
              <h1 className="logo-text">Welcome to replinq</h1>
              <h2>Surgical case coverage, simplified</h2>
              <a href="#aboutus" className="btn btn-primary float-start">
                learn more
              </a>
            </div>
            <div className="col-sm-7">
              <img src='\images\heroImagetrance.png' className='float-end' width='439' alt='' />
            </div>
          </div>
        </div>
        <div className="modal loginM" id="ModalRegistration">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className='row'>
                  <div className='col-12 col-md-6'>
                    <img src="\images\registrationLeftImg.png" className='leftImg' alt="" />
                  </div>
                  <div className='col-12 col-md-6'>
                    <button type="button" className="btn-close loginmdl" data-bs-dismiss="modal"></button>
                    <div className='formWrap frmregistr'>
                      <h2>Welcome to replinq</h2>
                      <span className='weback'>All your schedules in one place!</span>
                      <form onSubmit={handleSubmit(onSignUp)}>
                        <div className='row'>
                          <div className='col-12 mb-3'>
                            <input type='text' className='form-control' id='email' {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: "Email is invalid"
                              }
                            })} placeholder='Email' name='email' />
                            {errors.email ? (
                              <>
                                {errors.email.type === "required" && (
                                  <p className="errorMessage">
                                    {errors.email.message}
                                  </p>
                                )}
                                {errors.email.type === "pattern" && (
                                  <p className="errorMessage">
                                    {errors.email.message}
                                  </p>
                                )}
                              </>
                            ) : null}
                          </div>
                          <div className='col-12 mb-3'>
                            <input type='password' className='form-control' {...register("password", {
                              required: "Password is required",
                              minLength: { value: 8, message: "At least 8 character" }
                            })} placeholder='Password' name='password' />
                            {errors.password ? (
                              <>
                                {errors.password.type === "required" && (
                                  <p className="errorMessage">
                                    {errors.password.message}
                                  </p>
                                )}
                                {errors.password.type === "minLength" && (
                                  <p className="errorMessage">
                                    {errors.password.message}
                                  </p>
                                )}
                              </>
                            ) : null}
                          </div>
                          <div className='col-12 mb-3'>
                            <input type='password' className='form-control' {...register("c_pswd", {
                              required: "Please confirm password!",
                              validate: {
                                matchesPreviousPassword: (value) => {
                                  const { password } = getValues();
                                  return password === value || "Passwords should match!";
                                }
                              }
                            })} placeholder='Verify Password' name='c_pswd' />
                            {errors.c_pswd && (
                              <p className="errorMessage">
                                {errors.c_pswd.message}
                              </p>
                            )}
                          </div>
                          <div className='col-12 mb-3'>
                            <input type='text' className='form-control' placeholder='Company' {...register("company", {
                              required: "Company is required",
                              maxLength: { value: 100, message: "Max 100 character" }
                            })} name='company' />
                            {errors.company ? (
                              <>
                                {errors.company.type === "required" && (
                                  <p className="errorMessage">
                                    {errors.company.message}
                                  </p>
                                )}
                                {errors.company.type === "maxLength" && (
                                  <p className="errorMessage">
                                    {errors.company.message}
                                  </p>
                                )}
                              </>
                            ) : null}
                          </div>
                          <div className='col-12 mb-2 text-start'>
                            <span className='weback'>Vendor Credentialing Badge Information</span>
                          </div>
                          <div className='col-12 mb-3'>
                            <input type='text' className='form-control' placeholder='Intellicentric badge ID' {...register("intelli_badge_ID", {
                              required: !not_a_subs_one ? "Intellicentric badge ID is required" : false,
                              maxLength: { value: 100, message: "Max 100 character" }
                            })} name='intelli_badge_ID' />
                            {errors.intelli_badge_ID ? (
                              <>
                                {errors.intelli_badge_ID.type === "required" && (
                                  <p className="errorMessage">
                                    {errors.intelli_badge_ID.message}
                                  </p>
                                )}
                                {errors.intelli_badge_ID.type === "maxLength" && (
                                  <p className="errorMessage">
                                    {errors.intelli_badge_ID.message}
                                  </p>
                                )}
                              </>
                            ) : null}
                          </div>
                          <div className='col mb-3 text-start'>
                            <label className="form-check-label">
                              <input type="checkbox" onChange={(e) => setNot_a_subs_one(handleChange)} className="form-check-input" /> Not a Subscriber
                            </label>
                          </div>
                          <div className='col-12 mb-3'>
                            <input type='text' className='form-control' placeholder='Symplr badge ID' {...register("symplr_badge_ID", {
                              required: !not_a_subs_two ? "Symplr badge ID is required" : false,
                              maxLength: { value: 100, message: "Max 100 character" }
                            })} name='symplr_badge_ID' />
                            {errors.symplr_badge_ID ? (
                              <>
                                {errors.symplr_badge_ID.type === "required" && (
                                  <p className="errorMessage">
                                    {errors.symplr_badge_ID.message}
                                  </p>
                                )}
                                {errors.symplr_badge_ID.type === "maxLength" && (
                                  <p className="errorMessage">
                                    {errors.symplr_badge_ID.message}
                                  </p>
                                )}
                              </>
                            ) : null}
                          </div>
                          <div className='col mb-3 text-start'>
                            <label className="form-check-label">
                              <input type="checkbox" onChange={(e) => setNot_a_subs_two(handleChangesec)} className="form-check-input" /> Not a Subscriber
                            </label>
                          </div>
                          <div className='col-12'>
                            <input type='submit' disabled={isLoading} className='btn btn-primary' value='Sign Up' />
                          </div>
                          <div className='col-12 mt-3 mb-3 text-center'>
                            <div className='divider'>
                              <span>OR</span>
                            </div>
                          </div>
                          <div className='col-12 mb-3'>
                            <button 
                              type='button' 
                              className='btn btn-outline-danger w-100 d-flex align-items-center justify-content-center' 
                              onClick={onGoogleSignIn}
                              disabled={isLoading}
                            >
                              <img src="/images/icons/google-logo.svg" alt="Google" style={{ marginRight: '10px', height: '20px' }} /> Sign up with Google
                            </button>
                          </div>
                          <div className='col-12 mt-2 mb-2 text-center'>
                            Already have an account <Link to='#' data-bs-toggle="modal" data-bs-target="#mylogin" className='text-underline'>Login</Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="herobtmstrip" style={{ backgroundImage: "url(/images/herobtmstrips.png)" }} ></div>

    </>


  )
};

export default Header;
